<template>
  <div>
    <div class="col-12 bg-primary py-4 text-center">
      <LogoPublic />
    </div>
    <div class="col-12 py-4 text-center">
      <h4>The system is currently undergoing maintenance. Please check back later.</h4>
      <h5>We apologise for any inconvenice this may cause. For more information, please contact support at <a href="mailto: support@gdq.se">support@gdq.se</a></h5>
    </div>
  </div>
</template>
<script>
import LogoPublic from './LogoPublic.vue'
export default {
  name: 'MaintenanceMode',
  components: {
    LogoPublic
  }
}
</script>
